
import React, {Component} from 'react'

class CircularProgressIndicator extends Component {

    constructor(props) {
        super(props)
        this.state = {
            size: props.size !== undefined ? props.size : 60
        }
    }

    render() {
        let spinnerSize = this.state.size;

        return (
            <div className="spinner">
                <svg
                focusable="false"
                width={spinnerSize}
                height={spinnerSize}
                viewBox={`0 0 ${spinnerSize} ${spinnerSize}`}
                >
                <circle
                    cx={spinnerSize / 2}
                    cy={spinnerSize / 2}
                    r={spinnerSize / 2 - 10}
                />
                </svg>
            </div>
        )
    }
}

export default CircularProgressIndicator